import { render } from "./NavigationPhoneMenuLinkItem.vue?vue&type=template&id=554ec20c"
import script from "./NavigationPhoneMenuLinkItem.vue?vue&type=script&lang=js"
export * from "./NavigationPhoneMenuLinkItem.vue?vue&type=script&lang=js"

import "./NavigationPhoneMenuLinkItem.vue?vue&type=style&index=0&id=554ec20c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__